import type { Rive } from "@rive-app/react-canvas";
import React from "react";

import type { PhonemeSpan } from "../api/transcription";

import { VisemeAnimator } from "./VisemeAnimator";
import { useMultipleStateMachineInputs } from "./useMultipleStateMachineInputs";

const INPUT_NAMES = [
  "100",
  "101",
  "102",
  "103",
  "104",
  "105",
  "106",
  "107",
  "108",
  "109",
  "110",
  "111",
  "112",
  "113",
  "114",
  "115",
  "116",
  "117",
  "118",
  "119",
  "120",
];

export const useVisemeAnimator = (
  rive: Rive | null,
  phonemeSpans: PhonemeSpan[],
  stateMachineName: string,
) => {
  const visemeAnimatorRef = React.useRef<VisemeAnimator>();
  const animate = (startTime = 0) => {
    visemeAnimatorRef.current?.animate(startTime);
  };
  const stop = () => {
    visemeAnimatorRef.current?.stop();
  };

  const getInputFromName = useMultipleStateMachineInputs(
    rive,
    stateMachineName,
    INPUT_NAMES,
  );
  React.useEffect(() => {
    (async () => {
      visemeAnimatorRef.current = await VisemeAnimator.makeAnimator(
        phonemeSpans,
        getInputFromName,
      );
    })();
  }, [getInputFromName, phonemeSpans]);

  return { animate, stop };
};
